const {
  lazy,
  loadableReady,
  default: loadable,
} = require('@loadable/component');
const { default: LazyHydrate } = require('react-lazy-hydration');

module.exports = {
  loadable,
  lazy,
  loadableReady,
  LazyHydrate,
};
